import * as Popover from '@radix-ui/react-popover';
import styled, { keyframes } from 'styled-components';

import { theme } from '../../../common/ui/theme';

const VIEWPORT_EDGE_OFFSET = '50px';
const SEARCHABLE_MIN_DROPDOWN_HEIGHT = '83px'; // 2px border + 41px search section + 8px section padding + 32px option
const NON_SEARCHABLE_MIN_DROPDOWN_HEIGHT = '58px'; // 2px border + 8px section padding + 1.5 × 32px options

const popoverShow = keyframes`
    from {
        opacity: 0;
        transform: translateY(-2px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const popoverHide = keyframes`
    from {
        opacity: 1;
        transform: translateY(0);
    }

    to {
        opacity: 0;
        transform: translateY(-2px);
    }
`;

export const Content = styled(Popover.Content)<{
    $isSearchable: boolean;
    $maxHeight?: string;
    $minWidth: string;
    $width: string;
}>`
    background: ${theme.colors.background.default};
    border: 1px solid ${theme.colors.border.muted};
    border-radius: ${theme.radii[8]};
    box-shadow: ${theme.shadows.large};
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    max-height: min(
        ${(props) => props.$maxHeight ?? '70vh'},
        calc(var(--radix-popover-content-available-height) - ${VIEWPORT_EDGE_OFFSET})
    );
    min-height: ${(props) =>
        props.$isSearchable ? SEARCHABLE_MIN_DROPDOWN_HEIGHT : NON_SEARCHABLE_MIN_DROPDOWN_HEIGHT};
    min-width: ${(props) => props.$minWidth};
    outline: none;
    overflow: hidden;
    padding: 0;
    width: ${(props) => props.$width};
    z-index: ${theme.zIndex.interactive};

    &[data-state='open'] {
        animation: ${popoverShow} 120ms ease-out;
    }

    &[data-state='closed'] {
        animation: ${popoverHide} 90ms ease-in;
    }
`;
